import { ref, inject } from "vue";

const opened = ref(false);
const confirmDialogData = ref<IConfirmData>();
import { Emitter } from "mitt";
import IConfirmData from "../types/IConfirmData";

export default () => {
    const emitter = inject<Emitter<any>>("emitter"); // Inject `emitter`

    const show = (data: IConfirmData): Promise<boolean | string> => {
        if (data.type === undefined) {
            data.type = "danger";
        }

        confirmDialogData.value = data;
        opened.value = true;

        return new Promise((resolve, reject) => {
            if (emitter === undefined) {
                reject("Emitter is not defined!");
                return;
            }

            emitter.on("dialog-confirmed", (inputData: string) => {
                opened.value = false;

                if (inputData !== "" && inputData !== undefined) {
                    resolve(inputData);
                }

                resolve(true);
            });

            emitter.on("dialog-canceled", () => {
                opened.value = false;
                resolve(false);
            });
        });
    };

    return {
        opened,
        confirmDialogData,
        show,
    };
};
